export const HISTORY_LIST_SUCCESS = "HISTORY_LIST_SUCCESS";
export const HISTORY_LIST_ATTEMPT = "HISTORY_LIST_ATTEMPT";
export const HISTORY_LIST_FAILED = "HISTORY_LIST_FAILED";
/////////////////////
export const HISTORY_MORELIST_ATTEMPT = "HISTORY_MORELIST_ATTEMPT";
export const HISTORY_MORELIST_SUCCESS = "HISTORY_MORELIST_SUCCESS";
export const HISTORY_MORELIST_FAILED = "HISTORY_MORELIST_FAILED";
////////////////
export const HISTORY_REMOVE_SUCCESS = "HISTORY_REMOVE_SUCCESS";
export const HISTORY_REMOVE_FAILED = "HISTORY_REMOVE_FAILED";



